import SkeletonBlock from '@loaders/SkeletonBlock';

/**
 * Generic in-container skeleton for Suspense / shared fallbacks.
 * Prefer page-specific skeletons when available.
 */
const PageLoader = () => (
  <div
    className="flex w-full flex-col items-center bg-merchant-bg-subtle py-10 md:py-15 desktop:py-20 animate-fade-in"
    aria-busy="true"
    aria-label="Loading page"
  >
    <div className="flex w-full max-w-dashboard flex-col gap-section px-4 sm:px-6">
      <SkeletonBlock className="skeleton-title" />
      <SkeletonBlock className="skeleton-line h-6 w-80 max-w-full" />
      <div className="grid w-full grid-cols-1 gap-dashboard-cards md:grid-cols-2 xl:grid-cols-3">
        {[1, 2, 3].map((item) => (
          <SkeletonBlock key={item} className="skeleton-card" />
        ))}
      </div>
      <SkeletonBlock className="skeleton h-40 w-full rounded-dashboard-post md:h-[203px] desktop:h-[271px]" />
    </div>
  </div>
);

export default PageLoader;
